import { Component, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ColDef, GridOptions } from "ag-grid-community";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { JSIGNALBUTTON } from "src/app/shared/common/JsignalButtons";
import { JsignalService } from "src/app/shared/services/jsignal.service";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";
import { AlertLibCreateDialogComponent } from "../alert-lib-create-dialog/alert-lib-create-dialog.component";
import { AlertRuleService } from "src/app/shared/services/alert-rule.service";
import { constants } from "src/app/shared/common/contants";
import { GenericBadgeRendererComponent } from "src/app/shared/common/generic-badge-renderer.component";

@Component({
    selector: "app-alerts",
    templateUrl: "./alerts.component.html",
    styleUrls: ["./alerts.component.scss"],
    standalone: false
})
export class AlertsComponent implements OnInit {
  backgroundColorButton: string;
  columnDefs: ColDef[] = [];
  defaultColDef: ColDef = {};
  components: any;
  gridOptions: GridOptions = {};
  gridApi: any;

  alertsData = [];
  rowClassRules: any;
  getRowStyle: any;
  operatorMap: Record<string, string> = {
  GT: '>',
  GTE: '>=',
  LT: '<',
  LTE: '<=',
  EQ: '=',
  NE: '!=',
  ADD: '+',
  SUB: '-'
};

queryData:any;
  constructor(
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private jsignalsService: JsignalService,
    private localStorageSettings: LocalStorageSettingsService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private alertRuleService: AlertRuleService,
    private constants: constants
  ) {
    this.components = {
      jsignalButton: JSIGNALBUTTON,
    };
  }

  ngOnInit(): void {
     this.queryData=history.state?.selectedRowData
    this.intializeGrid();
    this.loadAlertsData();
  }

  intializeGrid() {
    // Set theme colors
    this.backgroundColorButton =
      this.localStorageSettings.getSettings("ColorA");
    this.columnDefs = [
      {
        headerName: "Action",
        sortable: false,
        filter: false,
        resizable: false,
        cellRenderer: "jsignalButton",
        pinned: "left",
        lockPinned: true,
        cellRendererParams: (params: any) => ({
          disableCheckBox: params.data?.status === "No",
          PopUpEdit: this.EditIcon.bind(this),
          // PopUpDelete: this.deleteIcon.bind(this),
        }),
        width:120,
      },

      {
        headerName: "Data Source",
        field: "dataSource",
        ...this.jsignalsService.autoTooltip("Data Source"),
      },

      {
        headerName: "Alerting Rule Name",
        field: "ruleName",
        ...this.jsignalsService.autoTooltip("Alerting Rule Name"),
      },

      {
        headerName: "Description",
        field: "description",
        ...this.jsignalsService.autoTooltip("Description"),
      },

      {
        headerName: "Logic Expression",
        headerTooltip: "Logic Expression",
        field: "logicExpression",
        valueFormatter: (params: any) => {
          if (!params.data.logicExpression) return "-";
          try {
            return this.buildLogicText(JSON.parse(params.value));
          } catch (e) {
            console.error(e, "Not Valid Json Displaying Original Value ");
            return params.data.logicExpression;
          }
        },
        tooltipValueGetter: (params: any) => {
          if (!params.value) return "-";

          let readable = "";
          let raw = params.value;

          try {
            readable = this.buildLogicText(JSON.parse(params.value));
          } catch (e) {
            console.error(e, "Not Valid Json Displaying Original Value");
            readable = params.value;
          }

          return `Logic Expression: ${readable}`;
        },

        width: 250,
      },

      {
        headerName: "Default Rule",
        headerTooltip: "Default Rule",
        field: "defaultRule", // boolean
        cellRenderer: (params: any) => {
          const isYes = params.value === true;
          const label = isYes ? "Yes" : "No";
          const badgeClass = isYes ? "status-badge yes" : "status-badge no";

          return `
        <span class="${badgeClass}">
          <span class="dot"></span>${label}
        </span>`;
        },
        
        //Custom tooltip
        tooltipValueGetter: (params: any) => {
          return `Default Rule : ${params.value === true ? "Yes" : "No"}`;
        },
      },

          {
      headerName: "Exception Allowed",
      field: "exceptionAllowed",
      headerTooltip: "Exception Allowed",

      valueFormatter: (params: any) => {
        if (params.value === true) return "True";
        if (params.value === false) return "False";
        return "";
      },

      tooltipValueGetter: (params: any) => {
        if (params.value === true) return "Exception Allowed : True";
        if (params.value === false) return "Exception Allowed : False";
        return "Exception Allowed :";
      },

    
    },

      {
        headerName: "Periodicity",
        field: "periodicity",
        ...this.jsignalsService.autoTooltip("Periodicity"),
      },

      {
        headerName: "Rule Type",
        field: "ruleType",
        ...this.jsignalsService.autoTooltip("Rule Type"),
      },

      {
        headerName: "Status",
        field: "status", // "Yes" | "No"
        cellRenderer: (params: any) => {
          const isYes = params.value === "Yes";
          const badgeClass = isYes ? "status-badge yes" : "status-badge no";

          return `
        <span class="${badgeClass}">
          <span class="dot"></span>${params.value}
        </span>`;
        },
        ...this.jsignalsService.autoTooltip("Status"),
      },
      {
  headerName: "Created Date",
  field: "createdDate",
  ...this.jsignalsService.autoTooltip("Created Date"),
},

{
  headerName: "Created By",
  field: "createdBy",
  ...this.jsignalsService.autoTooltip("Created By"),
},

{
  headerName: "Last Modified Date",
  field: "lastModifiedDate",
  ...this.jsignalsService.autoTooltip("Last Modified Date"),
},

{
  headerName: "Last Modified By",
  field: "lastModifiedBy",
  ...this.jsignalsService.autoTooltip("Last Modified By"),
},

    ];
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      filter: true,
      resizable: true,
    };

    this.gridOptions = {
      rowHeight: 40,
    };

    // if the record has status==no , row color will change
    this.rowClassRules = {
      sick: function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };
    this.getRowStyle = (params: any) => {
      console.log(params);
      console.log(params.data.status);
      if (params.data.status === "No") {
        return { backgroundColor: "rgb(211, 211, 211)" }; // Inline style for deleted rows
      }
      // return { backgroundColor: 'white', color: 'black' }; // Default style for other rows
    };
  }

  buildLogicText(logic: any): string {
    if (!logic) return "";

    // CASE 1: Group condition (AND / OR)
    if (logic.rules && logic.rules.length) {
      return (
        "(" +
        logic.rules
          .map((r: any) => this.buildLogicText(r))
          .filter(Boolean)
          .join(` ${logic.condition} `) +
        ")"
      );
    }

    // CASE 2: Single rule (leaf)
    if (logic.fieldName && logic.operator !== undefined) {
       const operatorLabel = this.operatorMap[logic.operator] || logic.operator;
       
      return `${logic.fieldName} ${operatorLabel} ${logic.value}`;
    }

    return "";
  }

  onGridReady(params: any) {
    this.gridApi = params.api;
  }

 EditIcon(params: any): void {
  // if (params.rowData.status === "No") {
  //   this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
  //   return;
  // }
  
  const row = params.rowData;
  console.log(row);

  // Open the dialog with edit mode data
  const dialogRef = this.dialog.open(AlertLibCreateDialogComponent, {
    maxWidth: "100vw",
    height: "95%",
    width: "90%",
    disableClose: true,
    data: {
      mode: "edit",
      rowData: row,
    },
  });

  // Subscribe to formSubmitted event (same as create)
  dialogRef.componentInstance.FormSubmitted.subscribe((result) => {
    if (!result) {
      return;
    }
    console.log("Updated form data:", result);
    // Call update API, passing dialog reference
    this.updateAlertRule(params.rowData.id, result.value, dialogRef);
  });

  // Handle manual closing ( cancel button)
  dialogRef.afterClosed().subscribe((result) => {
    console.log("Edit dialog closed");
    this.queryData=undefined
    // Perform cleanup if needed
    this.loadAlertsData();
  });
}
  deleteIcon(params: any): void {
    if (params.rowData.status === "No") {
      this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
      return;
    }
    this.spinner.start();

    this.alertRuleService.deleteAlertRule(params.rowData.id).subscribe({
      next: (res: any) => {
        this.spinner.stop();

        if (res?.error) {
          this.handleFailure(res);
          return;
        }

        this.handleSuccess(res);
        this.queryData=undefined
        this.loadAlertsData();
      },
      error: () => this.handleFailure(),
    });
  }

  onCreate() {
    console.log("Create clicked");
    // open create popup / route navigation
    const dialogRef = this.dialog.open(AlertLibCreateDialogComponent, {
      maxWidth: "100vw",
      height: "95%",
      width: "90%",

      disableClose: true,
    });

   // Subscribe to formSubmitted event from dialog component
  dialogRef.componentInstance.FormSubmitted.subscribe((result) => {
    if (!result) {
      return;
    }
    console.log("Alert form submitted:", result);
    // Call API to create alert rule, passing dialog reference
    this.createAlertRule(result.value , dialogRef);
    this.queryData=undefined
    this.loadAlertsData();
  });

  // This handles manual closing (X button, cancel button)
  dialogRef.afterClosed().subscribe((result) => {
    console.log("Dialog closed completely");
    this.queryData=undefined
    // Perform any cleanup if needed
    this.loadAlertsData();
  });
  }

  createAlertRule(formValue: any, dialogRef: MatDialogRef<AlertLibCreateDialogComponent>): void {
    const payload = this.buildAlertRulePayload(formValue);

    this.spinner.start();

    this.alertRuleService.createAlertRule(payload).subscribe({
      next: (res: any) => {
        this.spinner.stop();

        if (res.error) {
          this.handleFailure(res);
          return;
        }

        this.handleSuccess(res);
         dialogRef.close(true);
        
      },
      error: () => this.handleFailure(),
    });
  }

  updateAlertRule(id: number, formValue: any, dialogRef: MatDialogRef<AlertLibCreateDialogComponent>): void {
    const payload = this.buildAlertRulePayload(formValue);

    this.spinner.start();

    this.alertRuleService.updateAlertRule(id, payload).subscribe({
      next: (res: any) => {
        this.spinner.stop();

        if (res.error) {
          this.handleFailure(res);
          return;
        }

        this.handleSuccess(res);
        dialogRef.close(true);
        this.queryData=undefined
        this.loadAlertsData();
      },
      error: () => this.handleFailure(),
    });
  }

  buildAlertRulePayload(formValue: any): any {
    const DnsName = this.localStorageSettings.getSettings("dnsName");
    const Workspaceid = this.localStorageSettings.getSettings("WorkspaceId"); 
    return {
      ruleType: formValue.ruleType,
      dataSource: formValue.dataSource,
      ruleName: formValue.ruleName,
      description: formValue.description,
      logicExpression: JSON.stringify(formValue.logic), // key
      periodicity: formValue.periodicity,
      defaultRule: formValue.defaultRule,
      exceptionAllowed: formValue.exceptionAllowed,
      dnsId: DnsName,
      workspaceId: Workspaceid,
      active: formValue.active,
    };
  }

  onRefresh() {
    console.log("Refresh clicked");
    this.queryData=undefined
    this.loadAlertsData();
  }

  onDownload() {
    console.log("Download clicked");
    // export logic (CSV / Excel)

    this.spinner.start();

    setTimeout(() => {
      this.gridApi.exportDataAsCsv({
        fileName: "alertLibrary.csv",
      });

      this.spinner.stop();
    }, 500);
  }
  loadAlertsData() {
    this.spinner.start();

    this.alertRuleService.getAllActiveAlertRules().subscribe({
      next: (res: any) => {
        this.spinner.stop();

        if (res?.error) {
          this.handleFailure(res);
          return;
        }

        this.alertsData = res;
        
          if(this.queryData){
            
              let stateData=this.queryData
            let searchedRowData=this.alertsData.filter(item=>item.id==stateData.id)[0];
            this.onSearchEdit(searchedRowData)
          }
        this.spinner.stop();
      },
      error: () => this.handleFailure(),
    });
  }

  private handleFailure(res?: any): void {
    this.spinner.stop();

    const message = res?.statusMessage || "Operation failed. Please try again.";

    this.snackBar.open(message, "Ok", {
      duration: 4000,
    });
  }

  private handleSuccess(res: any): void {
    if (res && res.error === false) {
      this.snackBar.open(res.statusMessage, "Ok", {
        duration: 3000,
      });
    }
  }

   onSearchEdit(data: any): void {
  // if (params.rowData.status === "No") {
  //   this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
  //   return;
  // }
  
  const row = data;
  console.log(row);

  // Open the dialog with edit mode data
  const dialogRef = this.dialog.open(AlertLibCreateDialogComponent, {
    maxWidth: "100vw",
    height: "95%",
    width: "90%",
    disableClose: true,
    data: {
      mode: "edit",
      rowData: row,
    },
  });

  // Subscribe to formSubmitted event (same as create)
  dialogRef.componentInstance.FormSubmitted.subscribe((result) => {
    if (!result) {
      return;
    }
    console.log("Updated form data:", result);
    // Call update API, passing dialog reference
    this.updateAlertRule(row.id, result.value, dialogRef);
  });

  // Handle manual closing ( cancel button)
  dialogRef.afterClosed().subscribe((result) => {
    console.log("Edit dialog closed");
    this.queryData=undefined
    // Perform cleanup if needed
    this.loadAlertsData();
  });
}
}
